/**
 * Always return a given input value
 */
const always = (val: any) => () => val;
export default always;
